<script lang="ts">
	import { page } from "$app/state";
	import { BlogList } from "#lib/web-ui/home-buyers-template/content/index.js";

	const tag = $derived(page.url.searchParams.get("tag") || null);
</script>

<BlogList {tag} />
